const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254,267s10.8,4.37,19,5.14,20.82-5.14,22.88-15.94-4.89-31.1-7.2-35.47-16.2-35.22-23.91-41.9-20.31-10.55-22.88-11.57-.77,8.74-1.28,14.91-.52,37.53-.52,37.53l-1.8,41.13S247.78,264.41,254,267Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.33,162.33s-16.33,5.34-24,11.67-35.66,32.33-48,41-17,23-10.66,33.67S92.33,262,100.33,260s18-13.67,27-19,16-15,16-15,4.67-33.67,6.34-43.67,8-18.66,8-18.66S157.67,161.33,156.33,162.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.5,153s-25.79,7.18-32.79,9.18S147,179,146,196s-6,77-6.5,79.5S133.31,301,134.81,309,150.5,413,150.5,413s-4,6-3,7.5,1.5,9,1.5,9,12.5,4.5,20.5,4.5,18-3,18-3-2.5-18.5-1.5-29.5,1-83,1-83l10,114s12,3.5,22.5,3S241,429,241,429s1.5-8.5.5-12.5-7-11-7-13.5,5-86,5-86,3-23.5,2.5-35.5.5-40,.5-40,2-25.5,3.5-40S247.92,174,247.42,171s-24.92-13-30.92-15S198,153.5,190.5,153Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.36,211.9c-8.85-2.38-20.78-2.36-26.21-.47a24,24,0,0,0-9.09,6l-1.6,13.86a1.94,1.94,0,0,0-.44,1.06c-.06,1.18,1.6,3.23,6.45,5.18A59.09,59.09,0,0,0,117,241.1a59.28,59.28,0,0,0,18.8-1.82c5-1.49,6.85-3.38,6.91-4.55l.19-13.86C140.82,220.54,138,214.23,129.36,211.9Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.19,77.92S90.42,116.52,52.63,176,17.83,312,63.75,368.8s133.69,49.34,207.18,85.32,154.57,28.57,189.32-47.66S442.6,301.74,433.6,213.52,345.07-3.88,166.19,77.92Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.19,77.92S90.42,116.52,52.63,176,17.83,312,63.75,368.8s133.69,49.34,207.18,85.32,154.57,28.57,189.32-47.66S442.6,301.74,433.6,213.52,345.07-3.88,166.19,77.92Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.43,76c-4.68-2.56-6.81-.43-8.52-2.56s4.69-7.67-8.09-13.2c0,0-.85-11.93-18.32-12.36S346.72,59.84,342,62.82s-6-1.7-10.65,1.28-2.56,9-6.39,9.8-8.95-3.84-13.63-.85-4.69,5.53-6.82,5.53-6.39-1.7-8.94,0-5.54,3.84-5.54,3.84H397.84S399.12,78.58,394.43,76Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.68,74.28a15.7,15.7,0,0,1-1.9.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.74,54.38a7.27,7.27,0,0,0-4.16,5.2c-.78,3.9-2.6,6.5-4.68,6.76s-9.88-.52-11.18,2.34a11.36,11.36,0,0,0-.73,2.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.79,106.65c-2.46-1.34-3.57-.22-4.47-1.34s2.46-4-4.24-6.92c0,0-.45-6.26-9.6-6.48s-6.7,6.25-9.16,7.82-3.13-.9-5.58.67-1.34,4.69-3.35,5.13-4.7-2-7.15-.44-2.46,2.9-3.58,2.9-3.35-.89-4.69,0-2.9,2-2.9,2h56.51S342.25,108,339.79,106.65Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.36,105.73a6.63,6.63,0,0,1-1,.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.45,95.3A3.81,3.81,0,0,0,316.27,98c-.41,2-1.36,3.41-2.45,3.55s-5.18-.27-5.86,1.23a6,6,0,0,0-.39,1.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.58,201.5s45,4.45,67.77,32.33c0,0,24.08-32.3,67.34-31.63a87.41,87.41,0,1,0-135.12-.62Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.58,201.5s45,4.45,67.77,32.33c0,0,24.08-32.3,67.34-31.63a87.41,87.41,0,1,0-135.12-.62Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.86 65.16 121.34 409 128.94 409 122.86 65.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,225.33s15.18-27.32,42.51-35.67c0,0-28.85,6.83-43.27,30.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,147.91s15.18-27.33,42.51-35.68c0,0-28.85,6.83-43.27,30.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,186.62s15.18-27.33,42.51-35.68c0,0-28.85,6.83-43.27,30.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.89,167.64s-14.65-27.33-41-35.68c0,0,27.84,6.84,41.75,30.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.89,205.6s-14.65-27.33-41-35.68c0,0,27.84,6.83,41.75,30.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.8,230.93s38.6,3.82,58.16,27.75c0,0,20.66-27.72,57.78-27.15A75,75,0,1,0,345.79,231Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.8,230.93s38.6,3.82,58.16,27.75c0,0,20.66-27.72,57.78-27.15A75,75,0,1,0,345.79,231Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.68 113.93 401.38 409 407.89 409 402.68 113.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.63,251.38s13-23.45,36.48-30.61c0,0-24.75,5.86-37.13,26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.63,184.94s13-23.45,36.48-30.62c0,0-24.75,5.86-37.13,26.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.63,218.16s13-23.45,36.48-30.62c0,0-24.75,5.87-37.13,26.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.7,201.88s-12.57-23.46-35.2-30.62c0,0,23.89,5.86,35.83,26.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.7,234.45S390.13,211,367.5,203.83c0,0,23.89,5.86,35.83,26.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.64,410.23c.14-3.13-.28-9.06-3.68-18-5.33-14-14.66,14-14.66,14s0-3.33-10-14-18.67,8-18.67,8,4.67-44.66-6.67-41.33-10,41.33-10,41.33-8-28-18.66-28-13.34,20-13.34,20-2.66-35.33-13.33-36S124,385.57,124,385.57s3.34-40-7.33-42S102,358.23,102,358.23s-9.33-55.33-27.33-48.66-2.67,68-2.67,68S54,334.9,39.3,344.9C26,354,42.93,401.64,46.13,410.23Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.63,411.57s-8-25.34-4-29.34S58,395.57,58,395.57s-12.66-42.67,7.34-48S88.63,388.9,88.63,388.9s14.67-21.33,18-13.33A44.37,44.37,0,0,1,110,390.9s7.34-58,24-55.33,1.34,60,1.34,60,9.33-20,20-18S170,392.23,170,392.23s4.67-11.33,8-11.33,7.34,20,7.34,20,4-30.67,11.33-29.33S219.3,398.9,219.3,398.9s-2.67-14.67,5.33-15.33,12.67,22.66,12.67,22.66,10.66-22,17.33-18S258,413.57,258,413.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.3,
    y1: 411.57,
    x2: 70.63,
    y2: 381.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.96,
    y1: 410.23,
    x2: 121.3,
    y2: 391.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.96,
    y1: 411.57,
    x2: 197.96,
    y2: 394.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.63,
    y1: 410.9,
    x2: 157.96,
    y2: 397.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.3,
    y1: 398.9,
    x2: 80.63,
    y2: 388.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.96,
    y1: 404.23,
    x2: 113.3,
    y2: 394.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.96,
    y1: 403.57,
    x2: 150.63,
    y2: 397.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.3,
    y1: 402.9,
    x2: 203.3,
    y2: 396.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.22,410.23c.14-3.13-.28-9.06-3.68-18-5.33-14-14.66,14-14.66,14s0-3.33-10-14-18.67,8-18.67,8,4.67-44.66-6.67-41.33-10,41.33-10,41.33-8-28-18.66-28-13.34,20-13.34,20-2.66-35.33-13.33-36-22.67,29.34-22.67,29.34,3.34-40-7.33-42-14.67,14.66-14.67,14.66-9.33-55.33-27.33-48.66-2.67,68-2.67,68-18-42.67-32.66-32.67c-13.34,9.09,3.63,56.74,6.83,65.33Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.21,411.57s-8-25.34-4-29.34,21.33,13.34,21.33,13.34-12.66-42.67,7.34-48,23.33,41.33,23.33,41.33,14.67-21.33,18-13.33a44.37,44.37,0,0,1,3.33,15.33s7.34-58,24-55.33,1.34,60,1.34,60,9.33-20,20-18,14.66,14.66,14.66,14.66,4.67-11.33,8-11.33,7.34,20,7.34,20,4-30.67,11.33-29.33,22.67,27.33,22.67,27.33-2.67-14.67,5.33-15.33,12.67,22.66,12.67,22.66,10.66-22,17.33-18,3.33,25.34,3.33,25.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.88,
    y1: 411.57,
    x2: 275.21,
    y2: 381.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.54,
    y1: 410.23,
    x2: 325.88,
    y2: 391.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.54,
    y1: 411.57,
    x2: 402.54,
    y2: 394.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.21,
    y1: 410.9,
    x2: 362.54,
    y2: 397.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.88,
    y1: 398.9,
    x2: 285.21,
    y2: 388.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.54,
    y1: 404.23,
    x2: 317.88,
    y2: 394.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.54,
    y1: 403.57,
    x2: 355.21,
    y2: 397.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.88,
    y1: 402.9,
    x2: 407.88,
    y2: 396.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hen-house--inject-70"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.28,
    y: 335.82,
    width: 11.11,
    height: 77.75,
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.8,
    y: 335.82,
    width: 11.11,
    height: 77.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.28,
    y: 335.82,
    width: 11.11,
    height: 77.75,
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.8,
    y: 335.82,
    width: 11.11,
    height: 77.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.51,
    y: 335.82,
    width: 11.11,
    height: 77.75,
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.03,
    y: 335.82,
    width: 11.11,
    height: 77.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.23,
    y: 335.82,
    width: 11.11,
    height: 77.75,
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.75,
    y: 335.82,
    width: 11.11,
    height: 77.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.62,
    y: 335.82,
    width: 11.11,
    height: 77.75,
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.14,
    y: 335.82,
    width: 11.11,
    height: 77.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.47,164.07a4.77,4.77,0,0,0-6,.1l-67.09,55.91v12.39l70.23-58.53,74.95,58.4V220.28Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.95 340.24 301.23 340.24 301.23 222.92 367.54 167.83 438.95 222.92 438.95 340.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.67 340.24 420.89 340.24 420.89 296.16 375.67 265.22 375.67 340.24",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.56 340.24 230.84 340.24 230.84 222.92 297.15 167.83 368.56 222.92 368.56 340.24",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.7,
    y1: 199.37,
    x2: 335.39,
    y2: 199.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.49,
    y1: 227.14,
    x2: 437.64,
    y2: 227.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.49,
    y1: 254.9,
    x2: 438.28,
    y2: 254.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.49,
    y1: 282.67,
    x2: 375.67,
    y2: 282.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.49,
    y1: 310.44,
    x2: 376.16,
    y2: 310.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.82 166.83 368.21 166.83 441.29 223.11 370.9 223.11 297.82 166.83",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.88,
    y1: 181.06,
    x2: 386.32,
    y2: 181.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.73,
    y1: 195.38,
    x2: 404.71,
    y2: 195.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.57,
    y1: 209.69,
    x2: 423.34,
    y2: 209.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.82,219.2l-70.74-55.13a4.77,4.77,0,0,0-6,.1l-66.83,55.69v12.39l70-58.31,73.57,57.33Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.53 301.75 428.09 268.87 428.09 251.73 479.53 284.61 479.53 301.75",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.51 340.24 476.42 340.24 476.42 296.16 418.51 265.22 418.51 340.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.9 296.2 478.84 296.2 431.2 265.22 375.67 265.22 424.9 296.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.39 301.75 372.96 268.87 372.96 251.73 424.39 284.61 424.39 301.75",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.33,
    y: 275.98,
    width: 46.81,
    height: 64.26,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.33,
    y: 213.3,
    width: 46.81,
    height: 64.26,
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.33,
    y: 222.2,
    width: 46.81,
    height: 8.9,
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.28 340.24 320.88 340.24 287.66 413.57 240.06 413.57 273.28 340.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.45 350.89 316.05 350.89 313.18 357.24 265.58 357.24 268.45 350.89",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.75 372.31 306.35 372.31 303.47 378.66 255.87 378.66 258.75 372.31",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.04 393.73 296.64 393.73 293.77 400.08 246.17 400.08 249.04 393.73",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-70"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 197,
    cy: 449,
    rx: 155,
    ry: 21,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 197,
    cy: 449,
    rx: 155,
    ry: 21,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254,267s10.8,4.37,19,5.14,20.82-5.14,22.88-15.94-4.89-31.1-7.2-35.47-16.2-35.22-23.91-41.9-20.31-10.55-22.88-11.57-.77,8.74-1.28,14.91-.52,37.53-.52,37.53l-1.8,41.13S247.78,264.41,254,267Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.55,225.19a28.12,28.12,0,0,0-3.87-.24c-1.63-4.27-3.5-8.72-5.48-13,.75-.64,1.51-1.25,2.28-1.85l-.91-1.85c-.76.58-1.51,1.18-2.26,1.8a142.28,142.28,0,0,0-9-16.44c.5-1.4,1-2.69,1.38-3.85-.45-.75-.89-1.49-1.33-2.2-.42,1.16-.91,2.5-1.44,4a30.08,30.08,0,0,0-4-4.8,49.49,49.49,0,0,0-5.36-4.23q.9-3.21,1.65-5.69c-.56-.4-1.14-.79-1.73-1.17-.5,1.63-1.06,3.54-1.67,5.69a75.85,75.85,0,0,0-17-8l-.59,1.91a75.7,75.7,0,0,1,17,8.15c-.78,2.9-1.62,6.15-2.43,9.66a37.51,37.51,0,0,0-11-3.68l-.27,2A36.37,36.37,0,0,1,255.35,195c-.86,3.82-1.67,7.91-2.38,12.14a88.09,88.09,0,0,0-7.77-5.69l-1.07,1.69a89.1,89.1,0,0,1,8.47,6.31c-.65,4.15-1.18,8.4-1.52,12.66a60.35,60.35,0,0,0-7.61-5l-.94,1.76a61.17,61.17,0,0,1,8.38,5.7c-.18,2.94-.28,5.88-.24,8.76l2,0c0-2.34,0-4.72.15-7.12a42.54,42.54,0,0,1,4.74,4.92c-.34,1.42-.63,2.77-.88,4l1.23.24c-2,2.85-3.23,4.79-3.42,5.09l1.69,1.06.77-1.18.06.05s.44-.39,1.15-1l0,.22a27.8,27.8,0,0,1,6.43,2.53l-2,.92c-17.89,8.13-22.44,9.26-22.48,9.27l.45,1.95c.18,0,4.64-1.12,22.85-9.4q1.69-.76,3.18-1.5a19.28,19.28,0,0,1,7.46,8.93l-.13,0a30.82,30.82,0,0,0-5.62,1.36c-5.8,2.26-23.55,3.92-23.73,3.94l.19,2c.74-.07,18.21-1.7,24.27-4.06a29,29,0,0,1,5.24-1.26l.42-.08a19.59,19.59,0,0,1,.64,5.07,33.16,33.16,0,0,1-.17,3.42c-.68.19-1.35.36-2,.49-4.43.83-15.09,1.8-22.45,2.41L254,267l.84.33c6.85-.6,14.91-1.39,18.71-2.1.45-.09.91-.19,1.36-.3a20.39,20.39,0,0,1-2.61,7.14l.73.07a14.65,14.65,0,0,0,1.5.07,23.69,23.69,0,0,0,2.5-7.91,24.2,24.2,0,0,0,12.41-9.12c.11.35.22.71.3,1.07a15.78,15.78,0,0,1-1,10.94,21.55,21.55,0,0,0,3.1-2.86,18.33,18.33,0,0,0-.12-8.54,22.1,22.1,0,0,0-.92-2.92,18.72,18.72,0,0,0,1.54-4.6c.7-3.68-1.4-11.92-4.82-21.26a24.09,24.09,0,0,1,3.87.34C291.05,226.57,290.79,225.86,290.55,225.19Zm-5.95-.14a32.67,32.67,0,0,0-5.13.84c-1.11-2.26-2.59-5.2-4.26-8.36,1.43-1.46,2.91-2.88,4.42-4.24C281.42,217.19,283.11,221.19,284.6,225.05Zm-10.5,11.74a51.23,51.23,0,0,0-7.91-3c1.27-.77,2.64-1.53,4.09-2.26a1.93,1.93,0,0,1,.12.29,1,1,0,0,1,0-.35l.59-.29.34.49-.55.83.72.45.58-.57c.32-.32.53-.53,0-1.71a46.15,46.15,0,0,1,6.35-2.37c.62,1.27,1.05,2.17,1.23,2.56C279.55,231.37,278.85,233.46,274.1,236.79Zm7.22-4.57a10.63,10.63,0,0,1,4.38,11.88c-.06.24-.13.45-.2.67a37.1,37.1,0,0,0-9.38-7C279.41,235.37,280.78,233.49,281.32,232.22Zm-13.89-9.17c-.39-.61-.81-1.24-1.26-1.93a46.16,46.16,0,0,0-2.74-3.72c1.08-3.52,2.23-7.1,3.37-10.55,2,3.19,4.06,6.83,5.93,10.31C270.86,219.1,269.09,221.09,267.43,223.05Zm6.31-4c1.45,2.75,2.74,5.3,3.75,7.35a48.5,48.5,0,0,0-6.41,2.43c-.57-1-1.38-2.28-2.49-4C270.2,222.92,271.93,221,273.74,219.06Zm-6.5,7.4c.91,1.43,1.56,2.49,2,3.26a66.7,66.7,0,0,0-8.53,5.19C262.5,232.47,264.71,229.54,267.24,226.46ZM270.51,196a152.46,152.46,0,0,1,8.23,15.4c-1.55,1.37-3.07,2.8-4.54,4.28-2.07-3.83-4.36-7.84-6.59-11.24C268.62,201.41,269.61,198.55,270.51,196ZM260,184.55a48,48,0,0,1,4.58,3.66,32.33,32.33,0,0,1,4.57,5.64c-.9,2.56-1.9,5.42-2.93,8.47a30.88,30.88,0,0,0-4.21-5.06,28.93,28.93,0,0,0-4.37-3.23C258.41,190.61,259.22,187.41,260,184.55Zm-2.83,11.56a25.2,25.2,0,0,1,3.5,2.63,33.72,33.72,0,0,1,4.75,6c-1.18,3.53-2.38,7.23-3.52,10.9a77.09,77.09,0,0,0-7.15-6.94C255.45,204.3,256.28,200.07,257.16,196.11Zm1,32.6a46.88,46.88,0,0,0-5.17-5c.29-4.25.78-8.5,1.4-12.66a68.83,68.83,0,0,1,6.82,6.84C260.05,221.64,259,225.33,258.15,228.71Zm1.53,2.11.12-.09-.07-.09c.81-3.35,1.85-7.06,3-10.9.63.81,1.23,1.64,1.78,2.48s1.11,1.69,1.58,2.43c-2.78,3.37-5.2,6.58-7.09,9.22C259.19,232.9,259.43,231.87,259.68,230.82Zm.2,7.25c1.14-.88,2.6-1.93,4.29-3l-.06.27a47.83,47.83,0,0,1,8,2.8c-1.5.94-3.3,1.95-5.45,3A31.85,31.85,0,0,0,259.88,238.07Zm8.65,4.36c2.25-1.18,4.13-2.28,5.68-3.3a35.62,35.62,0,0,1,10.43,7.73c-1.81,3.31-5,4.39-8.6,5.11A21.07,21.07,0,0,0,268.53,242.43Zm8.7,19.65c.06-.87.1-1.78.1-2.75a21,21,0,0,0-.69-5.44c3.58-.75,7.15-1.95,9.36-5.38a21.29,21.29,0,0,1,2.51,4.27A21.41,21.41,0,0,1,277.23,262.08Zm13.06-14.2a16,16,0,0,1-.7,2.51A24.77,24.77,0,0,0,287,246.5a14.09,14.09,0,0,0,.63-1.93A12.9,12.9,0,0,0,281.43,230c-.19-.4-.54-1.16-1-2.16a30.76,30.76,0,0,1,5-.74C288.81,236.27,291,244.39,290.29,247.88Z",
    style: {
      fill: "#ccc"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254,267s10.8,4.37,19,5.14,20.82-5.14,22.88-15.94-4.89-31.1-7.2-35.47-16.2-35.22-23.91-41.9-20.31-10.55-22.88-11.57-.77,8.74-1.28,14.91-.52,37.53-.52,37.53l-1.8,41.13S247.78,264.41,254,267Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.06,233.82s12.09-9.26,21.34,3.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.93,98.38c-.52.86-.25-13.86,3.92-21,1.4-2.39,14.2-6.87,26.57-4s17.67,9.06,18.11,11.93S228,106.56,228,106.56,208.1,95.07,180.93,98.38Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.8,
    cy: 112.63,
    rx: 17.12,
    ry: 42.75,
    transform: "translate(70.92 303.85) rotate(-84.13)",
    style: {
      fill: "#a6a6a6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.33,162.33s-16.33,5.34-24,11.67-35.66,32.33-48,41-17,23-10.66,33.67S92.33,262,100.33,260s18-13.67,27-19,16-15,16-15,4.67-33.67,6.34-43.67,8-18.66,8-18.66S157.67,161.33,156.33,162.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.15,181.11c.5-5.48,1-9.93,1.41-12.75-.72.35-1.44.72-2.15,1.1-.4,3.14-.92,7.65-1.39,13a67.48,67.48,0,0,0-9.07,7.18c-1.5,1.44-3.2,2.9-5,4.36-.24-5.22-.38-9.47-.46-12.27l-2,1.73c.09,3,.24,7.14.48,12-4.3,3.27-9.22,6.56-14.16,9.81-.91-2.92-1.74-5.48-2.43-7.6l-1.64,1.43c.68,2.08,1.47,4.54,2.33,7.32l-1.24.81c-3.81,2.49-7.48,4.9-10.78,7.21A21.73,21.73,0,0,0,90.54,212c-.47-.26-.92-.48-1.36-.67-.63.49-1.24,1-1.83,1.41a14.86,14.86,0,0,1,2.35,1.08,19.64,19.64,0,0,1,2.67,1.85c-2.15,1.55-4.11,3.05-5.76,4.48A31.57,31.57,0,0,0,81.26,226a22.62,22.62,0,0,0-7.36.56q-.63,1.2-1.14,2.43A21.54,21.54,0,0,1,80,228c-4.74,8.27-4,18,2.27,28.56a1,1,0,0,0,.86.49.94.94,0,0,0,.51-.14,1,1,0,0,0,.35-1.37c-6-10.19-6.58-19.49-1.73-27.33a19.59,19.59,0,0,1,2.39.5,23.26,23.26,0,0,1,8,4.07c-.28.48-.56,1-.8,1.45-5.31,10.57,2.44,17.17,2.52,17.24a1,1,0,0,0,1.41-.13,1,1,0,0,0-.13-1.41c-.07-.06-6.62-5.64-2-14.8.17-.35.38-.7.58-1.06a43.93,43.93,0,0,1,8.14,10,9.49,9.49,0,0,0,.42,4.65,1,1,0,0,0,.9.55,1,1,0,0,0,.45-.1,1,1,0,0,0,.53-1q1.36,2.61,2.66,5.56a1,1,0,0,0,.92.6,1,1,0,0,0,.4-.09,1,1,0,0,0,.51-1.31,80.22,80.22,0,0,0-4.77-9.33,24.51,24.51,0,0,1,1.72-6,151.81,151.81,0,0,1,5.13,16c.57-.44,1.13-.9,1.7-1.37a143.78,143.78,0,0,0-5.67-17.05,34.83,34.83,0,0,1,5-7c1.76,6.72,3.42,13.8,4.74,20.69l1.76-1.46c-1.38-7-3.09-14.15-4.87-20.91.84-.82,1.74-1.63,2.71-2.42a62.58,62.58,0,0,1,6.92-4.8c.27,3.2.57,6.47.91,9.75a43.22,43.22,0,0,0-7.8,5.87,1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0,38.57,38.57,0,0,1,6.62-5.06c.38,3.58.82,7.17,1.3,10.7.45-.3.91-.59,1.36-.86l.49-.31c-.47-3.53-.89-7.11-1.27-10.68a121.33,121.33,0,0,1,10.8-5.54c.21,2.58.49,5.12.84,7.58.63-.67,1.22-1.32,1.76-1.92-.27-2.13-.5-4.31-.67-6.53,1.7-.75,3.29-1.42,4.66-2,.1-.71.21-1.47.33-2.3-1.46.58-3.21,1.3-5.14,2.14-.21-3.33-.32-6.71-.36-10.09,2.59-1.15,5-2.15,7-3,.1-.76.21-1.52.32-2.3-2.07.82-4.6,1.85-7.37,3.06,0-3.45.07-6.88.2-10.21,3.56-2.16,6.59-3.95,9-5.36.13-.87.26-1.72.38-2.54-2.35,1.37-5.47,3.22-9.26,5.5.22-4.59.52-9,.86-12.89a111.35,111.35,0,0,1,11-6.25c.29-.94.61-1.84.95-2.72A116.63,116.63,0,0,0,140.15,181.11ZM122.09,198c.14,2.73.31,5.66.51,8.73-4.4,2.79-8.38,5.44-12,8-.76-2.61-1.5-5.09-2.21-7.38C113.15,204.24,117.87,201.09,122.09,198Zm-16.17,11c.26-.16.51-.33.76-.5.72,2.34,1.47,4.85,2.24,7.5a90.57,90.57,0,0,0-8,6.67,39.49,39.49,0,0,0-5.35-6.74C98.73,213.69,102.27,211.37,105.92,209ZM93.69,231a25.11,25.11,0,0,0-8.5-4.3c-.56-.15-1.11-.27-1.65-.38a29.31,29.31,0,0,1,4.38-4.67c1.69-1.46,3.73-3,6-4.62a37.14,37.14,0,0,1,5.55,7A44.08,44.08,0,0,0,93.69,231Zm9.17,10.12a43.32,43.32,0,0,0-7.6-8.85,41.22,41.22,0,0,1,5.28-6.47,76.56,76.56,0,0,1,4.54,9.23A29.6,29.6,0,0,0,102.86,241.16Zm3.42-8.31A79.42,79.42,0,0,0,102,224.4a88.49,88.49,0,0,1,7.53-6.33c.71,2.49,1.43,5.08,2.14,7.75A37,37,0,0,0,106.28,232.85Zm9.06-10.41c-.72.58-1.39,1.17-2,1.77-.69-2.55-1.38-5-2.07-7.43,3.47-2.55,7.32-5.14,11.52-7.82q.25,3.89.59,8A67.44,67.44,0,0,0,115.34,222.44Zm9.33-14.7,2.31-1.45q5.43-3.37,9.94-6.11c-.11,3.23-.17,6.54-.15,9.87-3.71,1.68-7.7,3.64-11.52,5.8C125,213.07,124.84,210.36,124.67,207.74Zm1.66,20.08c-.34-3.29-.63-6.56-.9-9.76,3.71-2.13,7.66-4.1,11.36-5.79,0,3.37.17,6.74.4,10.06C133.73,223.89,129.9,225.76,126.33,227.82Zm10.68-30c-3.29,2-7,4.26-11.08,6.8l-1.41.88c-.2-3.18-.36-6.19-.5-9a81.09,81.09,0,0,0,6.32-5.37,63.6,63.6,0,0,1,7.46-6C137.48,189,137.2,193.3,137,197.79Z",
    style: {
      fill: "#ccc"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.33,162.33s-16.33,5.34-24,11.67-35.66,32.33-48,41-17,23-10.66,33.67S92.33,262,100.33,260s18-13.67,27-19,16-15,16-15,4.67-33.67,6.34-43.67,8-18.66,8-18.66S157.67,161.33,156.33,162.33Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.67,238.67a11.18,11.18,0,0,0-10.79,6.07,20.36,20.36,0,0,0,1.79,3.93,24,24,0,0,0,12.86,10.46c4.87-1.88,8.47-5.37,8.47-8.46C95,246.67,93.33,239,82.67,238.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,427.23l-11.82,11c-3.84,3.57-7.42,6.87-7.42,9.34s-1.37,5.77.55,7.42,10.72,3.58,19.24,3.58a28.68,28.68,0,0,0,18.15-6.87c3.29-2.75,3.57-6.33,7.14-8s9.9-1.37,11-5.49-.55-10.45-.55-10.45Z",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.82,438.23a13.32,13.32,0,0,0,.37-3.21c-4.15,3.38-12.84,6.9-15.52,9.27-3.12,2.76-5.88,9.72-21.37,10.56-13,.71-18.43-3.12-19.87-4.4-.25,1.76-.37,3.49.86,4.54,1.93,1.65,10.72,3.58,19.24,3.58a28.68,28.68,0,0,0,18.15-6.87c3.29-2.75,3.57-6.33,7.14-8S185.72,442.35,186.82,438.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,427.23l11.82,11c3.85,3.57,7.42,6.87,7.42,9.34s1.37,5.77-.55,7.42-10.72,3.58-19.24,3.58a28.65,28.65,0,0,1-18.14-6.87c-3.3-2.75-3.57-6.33-7.15-8s-9.89-1.37-11-5.49.55-10.45.55-10.45Z",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.16,438.23a13.32,13.32,0,0,1-.38-3.21c4.16,3.38,12.84,6.9,15.52,9.27,3.13,2.76,5.89,9.72,21.37,10.56,13,.71,18.43-3.12,19.88-4.4.24,1.76.36,3.49-.87,4.54-1.92,1.65-10.72,3.58-19.24,3.58a28.65,28.65,0,0,1-18.14-6.87c-3.3-2.75-3.57-6.33-7.15-8S202.26,442.35,201.16,438.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5,153s-25.79,7.18-32.79,9.18S147,179,146,196s-6,77-6.5,79.5S133.31,301,134.81,309,150.5,413,150.5,413s-4,6-3,7.5,1.5,9,1.5,9,12.5,4.5,20.5,4.5,18-3,18-3-2.5-18.5-1.5-29.5,1-83,1-83l10,114s12,3.5,22.5,3S241,429,241,429s1.5-8.5.5-12.5-7-11-7-13.5,5-86,5-86,3-23.5,2.5-35.5.5-40,.5-40,2-25.5,3.5-40S247.92,174,247.42,171s-24.92-13-30.92-15S198,153.5,190.5,153Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.6,205.49c-1.9-.84-3.85-1.62-5.87-2.34l.71-11.53c1.66.75,4.34,1.81,6,2.66l-.1-2q-2.84-1.49-5.74-2.76l.81-13.09c2,.94,3.9,1.94,5.79,3l.4-.7c0-.46,0-.91,0-1.34q-3-1.68-6.08-3.12L242,167c-.62-.33-1.26-.66-1.94-1l-.46,7.42c-2.78-1.22-5.61-2.3-8.48-3.26l1.16-7.79-1.89-.83-1.2,8a121.8,121.8,0,0,0-15.66-3.79l1.26-10.18c-.61-.15-1.27-.3-2-.43l-1.27,10.27a158.63,158.63,0,0,0-16.77-1.76l1-10.26-2-.12-1,10.28c-5.45-.22-10.73-.19-15.71,0,.18-2.6.34-4.92.48-6.88l-2.05.57c-.13,1.87-.28,4-.44,6.4-5.35.27-10.33.73-14.78,1.26q.33-1.89.63-3.57l-2.14.6c-.18,1-.37,2.09-.56,3.22-1.79.23-3.47.47-5.05.72A18.63,18.63,0,0,0,151.8,168c1.85-.29,3.87-.6,6-.88-.69,4.18-1.39,9-2,14.35-3.27.5-6.09,1-8.39,1.45q-.18,1-.33,2.1c2.26-.45,5.12-1,8.47-1.49-.4,3.42-.78,7.05-1.12,10.87-3.23.16-6,.34-8.36.5,0,.36,0,.71-.07,1.06s0,.63-.06,1c2.29-.17,5.09-.35,8.31-.51a384.36,384.36,0,0,0-.54,58.27l2-.14a382.12,382.12,0,0,1,.57-58.23c4.83-.21,10.46-.36,16.58-.35-1.09,16.77-2.18,34.46-2.74,46.3l2,.1c.56-11.86,1.65-29.59,2.75-46.4,4.65,0,9.56.16,14.6.43L185.61,235l2,.2,3.86-38.62c5.26.31,10.64.78,16,1.44l-3.63,29.21,2,.25,3.63-29.2c5.08.68,10.13,1.54,15,2.63l-5.14,34.5,2,.29,5.13-34.34c3.86.92,7.61,2,11.2,3.21l-2.36,38.21,2,.13,2.33-37.65q3,1.09,5.8,2.37C245.47,206.87,245.53,206.17,245.6,205.49Zm-32.35-37.83a121,121,0,0,1,15.62,3.82l-2,13.06a129.3,129.3,0,0,0-15.34-3.39ZM173,194c-6.09,0-11.7.14-16.54.35.35-3.9.75-7.6,1.16-11.09,4.68-.67,10.17-1.29,16.21-1.67C173.54,185.58,173.26,189.75,173,194Zm1-14.41c-6,.37-11.42,1-16.09,1.62.67-5.36,1.38-10.16,2.07-14.32,4.48-.54,9.53-1,15-1.3C174.61,169.74,174.29,174.49,173.94,179.59ZM243.68,227c-34.19-16.18-81.58-15.35-98.85-14.4q-.08,1-.15,2c17-1,64.83-1.9,98.82,14.51C243.56,228.46,243.62,227.75,243.68,227Zm-54-32.58c-5.07-.27-10-.4-14.67-.44.28-4.3.56-8.51.83-12.54,4.78-.25,9.87-.35,15.16-.2Zm1.52-15.17c-5.31-.15-10.42-.05-15.22.19.34-5.09.66-9.84.95-14,5-.2,10.22-.24,15.65,0ZM207.71,196c-5.38-.67-10.78-1.14-16.05-1.45L193,181.33a156.26,156.26,0,0,1,16.37,1.49Zm-14.53-16.66,1.38-13.79a157.44,157.44,0,0,1,16.72,1.76l-1.68,13.53A160,160,0,0,0,193.18,179.35Zm31.59,19.55c-4.91-1.09-10-2-15.07-2.63l1.63-13.14a124.39,124.39,0,0,1,15.29,3.41Zm13,3.57c-3.55-1.19-7.24-2.23-11-3.12l1.83-12.23a103.75,103.75,0,0,1,9.93,3.64Zm.85-13.82q-4.81-2-9.77-3.53l1.94-13q4.4,1.49,8.65,3.39Z",
    style: {
      fill: "#ccc"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.5,153s-25.79,7.18-32.79,9.18S147,179,146,196s-6,77-6.5,79.5S133.31,301,134.81,309,150.5,413,150.5,413s-4,6-3,7.5,1.5,9,1.5,9,12.5,4.5,20.5,4.5,18-3,18-3-2.5-18.5-1.5-29.5,1-83,1-83l10,114s12,3.5,22.5,3S241,429,241,429s1.5-8.5.5-12.5-7-11-7-13.5,5-86,5-86,3-23.5,2.5-35.5.5-40,.5-40,2-25.5,3.5-40S247.92,174,247.42,171s-24.92-13-30.92-15S198,153.5,190.5,153Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.88,
    y1: 170.11,
    x2: 188.66,
    y2: 210.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,318.5l10,114s12,3.5,22.5,3S241,429,241,429s1.5-8.5.5-12.5-7-11-7-13.5,5-86,5-86,3-23.5,2.5-35.5c-.06-1.33-.09-2.87-.11-4.53-1-3.21-5.6-18-9.21-33.54-4.08-17.57-8.38-34.49-8.38-34.49l-61-5c-2.82-.63-3.13,2.51-3.13,2.51l-18.68,47c-1,12-1.85,21.19-2,22.14C139,278,133.31,301,134.81,309S150.5,413,150.5,413s-4,6-3,7.5,1.5,9,1.5,9,12.5,4.5,20.5,4.5,18-3,18-3-2.5-18.5-1.5-29.5S187,318.5,187,318.5Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.63,215.82,211,219.9l-.56,25.7a7.43,7.43,0,0,1-2.79,5.65l-18.22,14.57a5.56,5.56,0,0,1-7.66-.68l-15.44-17.71a7.46,7.46,0,0,1-1.69-6.32Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.08,280.76s11.92,3.76,27.92.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.43,285.46l-.31,25.41.7-.61a13.47,13.47,0,0,0,4.58-9.51l.68-14.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.33,
    y1: 314.64,
    x2: 192.21,
    y2: 319.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7,148.75s-4.64,6.63-4.86,13.26-2.87,15,0,15.46,13-8.62,16.13-7.95,11.7,11.26,13.69,11,5.75-8.61,5.75-18.11-.67-11.49-6-14.58S189.77,141.46,182.7,148.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.23,152.73s1.55,13.92,6.41,16.34S207,156.26,208.1,155.6,196,156.93,186.23,152.73Z",
    style: {
      fill: "#ccc",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.59,130.45s4.06-4.89,6-2-.22,8.39-2.65,11.26a8.45,8.45,0,0,1-5.31,3.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.94,125.56s-4.41-5.31-6-.67,3.76,12.82,4.42,12.82h.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.4,109.64s-3.56,28.91-1.12,36,12,13.79,20.91,13.34,17.13-4.89,20-8,6.67-39.37,6.67-39.37-9.56-5.12-24.69-6.67S180.4,109.64,180.4,109.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.32,124.12a.52.52,0,1,1-.51-.51A.51.51,0,0,1,211.32,124.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.45,123.26a.52.52,0,1,1-.51-.51A.51.51,0,0,1,217.45,123.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.82,126.7a.52.52,0,1,1-1,0,.52.52,0,1,1,1,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,121.31a.52.52,0,1,0,.51-.51A.51.51,0,0,0,191.15,121.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,120.45a.52.52,0,1,0,.51-.51A.51.51,0,0,0,185,120.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.65,123.89a.52.52,0,1,0,.51-.51A.51.51,0,0,0,185.65,123.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.42,111.11a14.77,14.77,0,0,0-1.83,8,67.29,67.29,0,0,0,1.6,8.48l-.6,2.83,2.29-18.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.32,108.82a41,41,0,0,1,0,7.79,15.63,15.63,0,0,1-2.75,5.74l-.63,3.21,1.46-15.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.94,117.82s-2.87,10.61-2.43,11.71,4.2,2,7.29,1.55S205,117.6,205,117.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.53,119.15s3.1-2.21,7.29.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.12,117.16a4.71,4.71,0,0,1,6,.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.4,109s-7.74-.89-11.49,2.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,111.42s7.29-1.77,11.49,4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,134.39c-1.54,2.87-5.52,6-5.52,6s.22-8-2.65-8.4-13.26.22-18.34-1.54c0,0-10.16-1.55-10.6.66s-1.55,7.51-1.55,7.51-.88.44-2.43-3.53a42.25,42.25,0,0,1-2.12-8.44c-.5,7.66-.67,15.73.47,19,2.45,7.12,12,13.79,20.91,13.34s17.13-4.89,20-8c1.43-1.54,3.08-11.2,4.38-20.56A29.4,29.4,0,0,0,222,134.39Zm-12.59,9.94c-1.74,1-4.85,1.25-8.19,1.06-1.09-3.7-1.54-3.27-4.4-3.27-1.91,0-2.06,1.46-2,2.44a28,28,0,0,1-6-1.77c-4.2-2-.67-7.29-.67-7.29,6.41,2.43,22.09,1.54,22.09,1.54S213.63,141.9,209.43,144.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.22,206.41s.94,7.84,2.82,8.16,3.77-8.79,3.77-8.79S161.79,206.41,160.22,206.41Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.71,208.4s-.45,7.89,1.35,8.53,5.24-8,5.24-8S219.25,208.68,217.71,208.4Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,159.36S159,198.88,159,203.59s6.9,7.21,8.79-.63,5.64-45.17,5.64-45.17S167.43,157.16,163,159.36Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.21,158.73s-9.1,48-7.21,50.19,5.64,5.33,9.09-1.25,9.73-45.18,9.73-45.18S229.54,159,224.21,158.73Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.55,211.9a2,2,0,1,1-2-2A2,2,0,0,1,165.55,211.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7,215a2,2,0,1,1-2-2A2,2,0,0,1,221.7,215Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.18,248.22s7.71,2.57,6.17,11.56-7.46,9-9,8.74A55.33,55.33,0,0,1,254,267s3.86-4.88,2.06-10.28S254.47,247.7,262.18,248.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88,262.1a16.55,16.55,0,0,0,4.88,8.22c3.86,3.35,11.05,3.86,11.05,3.86a23.16,23.16,0,0,1-5.91,8.74c-4.11,3.6-8.74,8.74-10,12.08s1,2.32,2.57.26,3.6-5.4,3.6-5.4-2.06,6.94,0,5.66,3.34-6.69,3.34-6.69,0,6.69,1.54,5.15,1.29-6.43,1.29-7.2,2.82-1.55,4.37-3.09-4.89,0-4.89,0,9.26-6.42,10.8-8.74-2.32-6.43-3.34-7.71S223.88,262.1,223.88,262.1Z",
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.81,274.18a23.16,23.16,0,0,1-5.91,8.74c-4.11,3.6-8.74,8.74-10,12.08s1,2.32,2.57.26,3.6-5.4,3.6-5.4-2.06,6.94,0,5.66,3.34-6.69,3.34-6.69,0,6.69,1.54,5.15,1.29-6.43,1.29-7.2,2.82-1.55,4.37-3.09-4.89,0-4.89,0,9.26-6.42,10.8-8.74c.64-1,.34-2.25-.3-3.51C242.27,270.43,239.81,274.18,239.81,274.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.89,252.76a16.61,16.61,0,0,0,4.89,8.22c3.85,3.34,11.05,3.86,11.05,3.86a23.3,23.3,0,0,1-5.91,8.74c-4.11,3.6-8.74,8.74-10,12.08s1,2.32,2.57.26,3.6-5.4,3.6-5.4-2.05,6.94,0,5.66,3.34-6.69,3.34-6.69,0,6.69,1.55,5.14,1.28-6.42,1.28-7.19,2.83-1.55,4.37-3.09-4.88,0-4.88,0,9.25-6.43,10.8-8.74-2.32-6.43-3.35-7.71S222.89,252.76,222.89,252.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.83,264.84a23.3,23.3,0,0,1-5.91,8.74c-4.11,3.6-8.74,8.74-10,12.08s1,2.32,2.57.26,3.6-5.4,3.6-5.4-2.05,6.94,0,5.66,3.34-6.69,3.34-6.69,0,6.69,1.55,5.14,1.28-6.42,1.28-7.19,2.83-1.55,4.37-3.09-4.88,0-4.88,0,9.25-6.43,10.8-8.74c.64-1,.34-2.25-.31-3.51C241.28,261.09,238.83,264.84,238.83,264.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.67,221s-8-6-14,.33-2.67,20.34,1.33,26,23.33,12.34,35,11.34,20.33-13.67,20.33-20.34-5.66-11.33-10-11.66S244.67,225,244.67,225,228.33,224,224.67,221Z",
    style: {
      fill: "#cfcfcf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,209.86s1.43-2.67-.1-7.48-4.81-5-4.81-3.72v2s-3.27-3.5-4.15-2.84-.22,4.37-.22,4.37S252.65,203.79,255,209.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,209.86s-2.19-6.59-7.84-8.16-11.92,1-14.12,3.46a123.87,123.87,0,0,0-8.15,11.6c-2.2,3.45-13.49,8.79-11.29,10.67s8.15-.94,8.15-.94-4.08,6.27.94,5.33,5.34-3.14,5.34-3.14-1.26,7.85,2.19,6.59,3.14-4.08,3.14-4.08-1.57,7.22,1.88,7.22,4.08-5,4.08-5,.94,6.59,5,5.64,1.88-4.7,1.88-4.7,5,4.39,6,1.88-1.88-7.21-1.88-7.21-3.45-7.53-.32-10.67,9.73-5,9.73-5Z",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.07,215.19c.21.19.42.36.63.53a35.74,35.74,0,0,1,6-2.41L255,209.86S249.62,212.06,253.07,215.19Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.39,208.39a1.21,1.21,0,1,1-1.2-1.2A1.2,1.2,0,0,1,249.39,208.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.38,253.87s-6.17,2.57-9.77-.26-9-7.19-13.88-7.19-5.4,4.11-3.09,5.65,7.72,5.66,7.72,5.66-7.2.25-11.31-3.09-7-9.25-9.77-9,.25,5.92.25,5.92-4.11-4.63-5.65-2.83,2.83,7.71,4.88,10.8S233.13,267,236.22,268a16.18,16.18,0,0,0,4.37,1S251.13,267.5,254,267s5.66-1.28,6.69-5.4S261.15,254.64,260.38,253.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.53,251.56s3.6,7.71,9.26,10.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,235.75l-55.25-2.5L92,260h.28c1.6,6.07,11.92,11.14,24.65,11.73,5.77.27,12.11-.11,17.61-2.21,5.73-2.18,7.79-7.67,8.54-13.32C143.39,253.93,144.53,235.73,145,235.75Z",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62,245.33q-1.87,0-3.78-.09a63.63,63.63,0,0,1-20-3.87c-7.66-3.07-9.13-6.65-9-9.12s1.91-5.89,9.83-8.25a63.88,63.88,0,0,1,20.3-2,63.63,63.63,0,0,1,20,3.87c7.66,3.07,9.13,6.65,9,9.12h0c-.12,2.46-1.91,5.89-9.83,8.25A59.7,59.7,0,0,1,120.62,245.33Zm-6.51-19.41a55.29,55.29,0,0,0-15.36,1.92c-5.06,1.5-6.92,3.41-7,4.6s1.62,3.26,6.51,5.22A59.56,59.56,0,0,0,117,241.24a59.75,59.75,0,0,0,19-1.83c5.06-1.5,6.92-3.41,7-4.6h0c.06-1.18-1.62-3.26-6.51-5.22A59.56,59.56,0,0,0,117.73,226C116.51,226,115.3,225.92,114.11,225.92Z",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-70)"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.38,
    cy: 233.55,
    rx: 9.54,
    ry: 27.37,
    transform: "translate(-121.36 339.98) rotate(-87.34)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.65,234.44c-3,2.62-7.31,2.59-9.66-.08s-1.83-7,1.15-9.59,11-5.84,13.35-3.17S123.63,231.81,120.65,234.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,229.7c0,4-2.88,7.19-6.44,7.19s-6.44-3.22-6.44-7.19,2.89-12.12,6.44-12.12S115,225.72,115,229.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.85,233.91c0,4-2.89,7.2-6.44,7.2s-6.44-3.23-6.44-7.2,2.88-12.12,6.44-12.12S133.85,229.93,133.85,233.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.43,239.11c0,4-2.89,7.2-6.44,7.2s-6.44-3.23-6.44-7.2S115.43,227,119,227,125.43,235.13,125.43,239.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.61,234.65c0,4-2.88,7.2-6.44,7.2s-6.44-3.22-6.44-7.2,2.88-12.12,6.44-12.12S105.61,230.68,105.61,234.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.28,234.65c0,4-2.89,7.2-6.44,7.2s-6.44-3.22-6.44-7.2,2.88-12.12,6.44-12.12S141.28,230.68,141.28,234.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.23,242.86c-3,2.63-7.31,2.59-9.66-.08s-1.84-7,1.15-9.59,11-5.84,13.35-3.17S115.21,240.23,112.23,242.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.79,235.33c2.76,2.86,2.92,7.19.36,9.65s-6.88,2.15-9.63-.71-6.34-10.73-3.77-13.2S134,232.47,136.79,235.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.51,235.93a2,2,0,0,1-2-1.82l-1.11-19.79a22.13,22.13,0,0,0-11.48-17.51l-2.17-1.18a22.2,22.2,0,0,0-32.55,15.94l-3.24,20a2,2,0,0,1-3.94-.64l3.24-20a26.2,26.2,0,0,1,38.41-18.82l2.17,1.19A26.16,26.16,0,0,1,145.4,214l1.1,19.79a2,2,0,0,1-1.81,2.17Z",
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,272.67s.87.13,5.87.8,13-2.16,14.13-6.14c.59-2-3.67-2-6.67-.66S99,272.67,99,272.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.67,247s5.66-2.33,11,.67a53.74,53.74,0,0,1,10,7.66s1.66,2-1.67,4-4,.67-6.67-1.33A14.07,14.07,0,0,0,94,255.67s6.67,6.33,9,8.33,9-1.67,11,1,1,3.67-4.67,5.33S98.33,275,93.67,272s-15.67-15.33-17-19.33S83,244.33,87.67,247Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.14677e25b02c4397e98a3ff8dc1ab493.svg";
export { ForwardRef as ReactComponent };